import { firstLetter } from "../../utils/stringUtils";

export const getUserInitials = (user?: { first_name?: string; last_name?: string }) =>
  `${firstLetter(user?.first_name)}${firstLetter(user?.last_name)}`;
